import { Http, Consts, UploadService } from 'gw-js-lib';
import { isEmpty } from 'lodash';
import Vue from 'vue';
// eslint-disable-next-line
import store from '@/store/store';

function GetCurrentCourse() {
  if (!isEmpty(store.state.course)) {
    return store.state.course;
  }
}

// ------------------------------- START User services ----------------------------------
// eslint-disable-next-line
const VUE_APP_API_USER = process.env.VUE_APP_API_USER;

export const Login = ({ email, password }) => (
  Http({
    url: `${VUE_APP_API_USER}/auth/v2`,
    method: 'post',
    body: { username: email, password },
    showError: true,
    errorList: { 1: Consts.Context.APP.$t('login.invalidCredentials') },
  })
);

export const ForgotPassword = ({ username }) => (
  Http({
    url: `${VUE_APP_API_USER}/forgot-password`,
    method: 'post',
    body: { username },
    showError: true,
    errorList: {},
  })
);

export const GetMe = () => (
  Http({
    url: `${VUE_APP_API_USER}/me`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);


export const UpdateMe = (data) => (
  Http({
    url: `${VUE_APP_API_USER}/me`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {

    return response;
  })
);
// eslint-disable-next-line
export const UploadPhoto = (user_id, formData, percentCompleted) => (
  // eslint-disable-next-line
  UploadService().put(`${VUE_APP_API_USER}/${user_id}/photo`, formData, {
    onUploadProgress: (progressEvent) => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    },
  })
);

/**
 * Current version to upload a new photo to the User
 * @param {*} user_id 
 * @param {*} photo Object {file, name}
 */
export const uploadUserPhotoV2 = (user_id, photo) => {
  const formData = new FormData();
  formData.append('photo', photo.file, photo.name);
  return (
    UploadService().put(`${VUE_APP_API_USER}/${user_id}/photo/v2`, formData).then((resPhoto) => {
      return (resPhoto && resPhoto.data) ? resPhoto.data.data : null;
    })
  ); 
}

export const ChangePassword = (currentPassword, newPassword) => (
  Http({
    url: `${VUE_APP_API_USER}/change-password`,
    method: 'post',
    body: { 
      password: currentPassword,
      new_password: newPassword
     },
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('settings.wrongPassword'),
    },
  })
);

export const setDefaultCourse = (golfCourseId) => (
  Http({
      url: `${VUE_APP_API_USER}/default-course/${golfCourseId}`,
      method: 'put',
      body: null,
      showError: true,
      errorList: { },
  })
);

// ------------------------------- END User services ----------------------------------


// ------------------------------------------- START Sensor services ----------------------------
// eslint-disable-next-line
const VUE_APP_API_SENSOR = process.env.VUE_APP_API_SENSOR;

export const GetSensors = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/bycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensor = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetSensorStatus = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/status`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetRssiRanges = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/rssi`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const ActivateSensor = (id, data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/activate`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {
      200: Consts.Context.APP.$t('sensors.sensorStatusError'),
      201: Consts.Context.APP.$t('sensors.sensorSignalError'),
    },
  })
);

export const GetSensorRSSI = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/rssi`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetAlertBySensor = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/alert/opened`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetAlertByStation = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alert/station/${id}/opened`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetAlertByCourse = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alert/opened/bycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetAlertsDashboard = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alert/dashboard/allbycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetSensorRingGraph = (sensorId) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensorId}/ring-graph`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const CleanUpSensor = (sensorId, password) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensorId}/clean-up`,
    method: 'put',
    body: {password: password},
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('settings.wrongPassword'),
    },
  })
);

export const MoveToInventory = (sensorId) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensorId}/to-inventory`,
    method: 'put',
    body: {},
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('settings.wrongPassword'),
    },
  })
);

export const GetSensorData = (id , {limit, next}) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/data?limit=${limit ? limit : ''}&next=${next ? encodeURI(next) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const UpdateGPS = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/command/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  })
);

export const getSensorGraph = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${data.sensorId}/graph/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getDailyTemps = (sensorId) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/sensor-daily-readings/${sensorId}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

// ------------------------------------------- END Sensor services ----------------------------


// ------------------------------------------- START Golf-Course Services ----------------------
// eslint-disable-next-line
const VUE_APP_API_COURSE = process.env.VUE_APP_API_COURSE;

export const GetHoles = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/hole/bycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const GetZones = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/zone`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetLocalWeather = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${GetCurrentCourse().course_id}/weather/local/last-reading`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const GetMicroWeather = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${GetCurrentCourse().course_id}/weather/stations/last-reading`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);


export const GetWeatherPrecipitation = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${GetCurrentCourse().course_id}/weather/stations/precipitation-totals`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
)

export const getStationGraph = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${data.device_sn}/graph/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getStationData = (device_sn, {limit, next}) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${device_sn}/data?limit=${limit ? limit : ''}&next=${next ? encodeURI(next) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetSoilTypes = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/soil-type`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetStationMinMaxTemps = (deviceSn) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/min-max/${deviceSn}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

// ------------------------------------------- END Golf-Course Services ----------------------------

// ------------------------------------------- START Task Manager Services ----------------------
const VUE_APP_API_TASK = process.env.VUE_APP_API_TASK;
export const SaveTask = (data) => (
  Http({
    url: `${VUE_APP_API_TASK}/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  })
);

export const SaveTaskComment = (data) => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  })
);

export const GetUsers = () => (
  Http({
    url: `${VUE_APP_API_USER}/bycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const GetTasks = (pagination) => (
  Http({
    url: `${VUE_APP_API_TASK}/search`,
    method: 'post',
    body: pagination,
    showError: true,
    errorList: {},
  })
);

export const GetTasksDashboard = () => (
  Http({
    url: `${VUE_APP_API_TASK}/dashboard/bycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const GetRecentCommentsDashboard = () => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/recent/bycourse/${GetCurrentCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const GetTask = (taskid) => (
  Http({
    url: `${VUE_APP_API_TASK}/${taskid}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const UpdateTaskStatus = (taskid , taskStatus) => (
  Http({
    url: `${VUE_APP_API_TASK}/${taskid}/status`,
    method: 'put',
    body: { status: taskStatus},
    showError: true,
    errorList: {},
  })
);

export const AddTaskComment = (comment) => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/`,
    method: 'post',
    body: comment,
    showError: true,
    errorList: {},
  })
);
// ------------------------------------------- END Task Manager services ----------------------------

export const GetWeatherStations = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${GetCurrentCourse().course_id}/weather/station/`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);